import {isNil} from 'ramda';

import {getSafely, Nullish} from 'shared/web';

/**
 * Property ordering for "Same & better" logic.
 * Each group defines values from "lowest" (index 0) to "best" (last index).
 * A "Same & better" selection includes the vehicle's value and all higher values.
 */

const TRANSMISSION_ORDER = ['TRANSMISSION_MANUAL', 'TRANSMISSION_AUTOMATIC'];

const DRIVE_ORDER = ['DRIVE_4X2', 'DRIVE_4X4'];

const VAT_ORDER = ['NO', 'YES'];

export type OrderableGroup = 'transmission' | 'drive' | 'vat';

const ORDER_MAP: Record<OrderableGroup, string[]> = {
  transmission: TRANSMISSION_ORDER,
  drive: DRIVE_ORDER,
  vat: VAT_ORDER,
};

/**
 * Returns the vehicle's value plus all "better" values for a given group.
 * For groups where the vehicle value is unknown or not in the list, returns all values.
 */
export function getBetterOrEqualValues(
  group: OrderableGroup,
  vehicleValue: string | Nullish
): string[] {
  const effectiveOrder = getSafely(ORDER_MAP, group) ?? [];
  if (isNil(vehicleValue)) {
    return effectiveOrder;
  }

  const idx = effectiveOrder.indexOf(vehicleValue);

  if (idx === -1) {
    return [vehicleValue];
  }

  return effectiveOrder.slice(idx);
}
